import { useEffect } from 'react';
import { getProfile } from '@/services/rbac-auth.service';
import { useAuthStore } from '@/stores/auth.store';

/**
 * Al montar la app: intenta /me/profile con la cookie. Si hay sesión → puebla el store
 * (authenticated); si no → unauthenticated. Reemplaza el hydrate() que leía localStorage.
 */
export function useSessionBootstrap(): void {
  const status = useAuthStore((s) => s.status);
  useEffect(() => {
    if (status !== 'idle') return;
    useAuthStore.getState().setLoading();
    getProfile()
      .then((p) => useAuthStore.getState().setFromProfile(p))
      .catch(() => useAuthStore.getState().clearAuth());
  }, [status]);
}
